import { isEventCard } from "@clockwise/web-commons/src/components/EventCard/EventCard";
import React from "react";
type FlexMeeingCardColumnProps = {
  emptyMessage?: string;
  heading?: string;
  onFlexibilityChange?: (eventId: string, isFlexible: boolean) => void;
};

export const FlexMeeingCardColumn = ({
  children,
  heading,
  onFlexibilityChange,
}: React.PropsWithChildren<FlexMeeingCardColumnProps>) => {
  if (!React.Children.count(children) || React.Children.count(children) < 1) {
    return null;
  }

  const childrenWithProps = React.Children.map(children, (child) => {
    if (isEventCard(child)) {
      return React.cloneElement(child as JSX.Element, {
        onFlexibilityChange,
        ...child.props,
      });
    }
    return child;
  });

  return (
    // TODO: Add CW-IDs for each Column created, https://linear.app/getclockwise/issue/FOU-1473/revisit-flexible-meeting-columns-to-add-cw-ids-to-each-column
    <div className="cw-flex cw-border cw-rounded cw-p-2 cw-justify-center cw-w-full">
      <div className="cw-space-y-2 cw-w-full">
        {!!heading && (
          <>
            <div className="cw-heading-caption">{heading} </div>
            <div className="cw-border cw-border-x-0 cw-border-t-0 cw-border-solid cw-border-brand-emphasis" />
          </>
        )}
        {childrenWithProps}
        <div className="cw-w-full cw-h-4 cw-bg-brand cw-hidden md:cw-flex" />
      </div>
    </div>
  );
};
